import React, { useEffect, useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import { Phone, User, MessageCircle } from "lucide-react";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import { AuthContext } from "../../context/Auth/AuthContext";
import ContactAvatar from "../ContactAvatar";

const VcardPreview = ({ contact, numbers }) => {
  const history = useHistory();
  const { user } = useContext(AuthContext);

  const [selectedContact, setContact] = useState({
    name: contact || "",
    number: numbers ? numbers.replace(/\D/g, "") : "",
    profilePicUrl: "",
  });

  useEffect(() => {
    const timer = setTimeout(async () => {
      try {
        const cleanNumber = numbers ? numbers.replace(/\D/g, "") : "";
        if (!cleanNumber && !contact) return;
        const { data } = await api.post("/contact", {
          name: contact || "Contacto",
          number: cleanNumber,
          email: "",
        });
        setContact(data);
      } catch {
        setContact({
          name: contact || "Contacto",
          number: numbers ? numbers.replace(/\D/g, "") : "",
          profilePicUrl: "",
        });
      }
    }, 500);
    return () => clearTimeout(timer);
  }, [contact, numbers]);

  const handleNewChat = async () => {
    try {
      const { data: ticket } = await api.post("/tickets", {
        contactId: selectedContact.id,
        userId: user.id,
        status: "open",
      });
      history.push(`/tickets/${ticket.id}`);
    } catch (err) {
      toastError(err);
    }
  };

  const displayName = selectedContact.name || contact || "Contacto";
  const displayNumber = selectedContact.number || (numbers ? numbers.replace(/\D/g, "") : "");

  return (
    <div className="min-w-[260px] max-w-[320px] rounded-xl overflow-hidden border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800">
      <div className="flex items-center gap-3 px-3.5 py-3 bg-slate-50 dark:bg-slate-700/50">
        <ContactAvatar
          src={selectedContact.profilePicUrl}
          alt={displayName}
          className="w-11 h-11 rounded-full object-cover flex-shrink-0"
          fallbackClassName="w-11 h-11 rounded-full bg-indigo-600 flex items-center justify-center flex-shrink-0"
          size="md"
          contactId={selectedContact.id}
        />
        <div className="min-w-0">
          <p className="text-sm font-semibold text-slate-900 dark:text-slate-100 truncate">{displayName}</p>
          {displayNumber && (
            <div className="flex items-center gap-1 mt-0.5">
              <Phone className="w-3 h-3 text-slate-400 flex-shrink-0" />
              <span className="text-xs text-slate-500 dark:text-slate-400 truncate">{numbers || displayNumber}</span>
            </div>
          )}
        </div>
      </div>
      <div className="border-t border-slate-200 dark:border-slate-700">
        <button
          onClick={handleNewChat}
          disabled={!selectedContact.number && !displayNumber}
          className="w-full flex items-center justify-center gap-1.5 py-2 text-sm font-semibold text-indigo-600 dark:text-indigo-400 hover:bg-slate-50 dark:hover:bg-slate-700/50 disabled:opacity-40 transition-colors"
        >
          <MessageCircle className="w-4 h-4" />
          Iniciar conversación
        </button>
      </div>
    </div>
  );
};

export default VcardPreview;
